import OriginalTable from './Table.svelte';
import OriginalHeader from './Header.svelte';
import HeaderRow from './HeaderRow.svelte';
import OriginalBody from './Body.svelte';
import OriginalRow from './Row.svelte';
import Cell from './Cell.svelte';
import Footer from './Footer.svelte';
const Table = OriginalTable;
Table.Header = OriginalHeader;
Table.Header.Row = HeaderRow;
Table.Body = OriginalBody;
Table.Body.Row = OriginalRow;
Table.Body.Row.Cell = Cell;
Table.Footer = Footer;
export default Table;
